<template>
	<footer>
		<div>
			<div></div>
			<div>Værnedamsvej 7A  |  1819 Frederiksberg C  |  Telefon: 60550658</div>
			<div><a href="mailto:info@imagemakers.dk">info@imagemakers.dk</a></div>
		</div>
		<div><a href="https://egello.com">egello development</a></div>
	</footer>
</template>

<script>
	export default {
		name: "Footer"
	};
</script>